import { AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  fetchSchemaSelectionFailure,
  fetchSchemaSelectionSuccess,
} from "./actions";
import { FETCH_SCHEMASELECTION_REQUEST } from "./actionTypes";
import { FetchSchemaSelectionRequest, ISchemaSelection } from "./types";
import { getSchemaData } from "./service";

/*
  Worker Saga: Fired on FETCH_SchemaSelection_REQUEST action
*/
function* fetchSchemaSelectionSaga(action: FetchSchemaSelectionRequest) {
  try {
    const response: AxiosResponse<ISchemaSelection[]> = yield call(getSchemaData, action.params);

    yield put(
      fetchSchemaSelectionSuccess({
        schemaSelection: response.data,
      })
    );
  } catch (e: any) {
    yield put(
      fetchSchemaSelectionFailure({
        error: e.message,
      })
    );
  }
}

/*
  Watcher saga - intercept the action fired from view
  Starts worker saga on latest dispatched `FETCH_SchemaSelection_REQUEST` action.
  Allows concurrent increments.
*/
function* schemaDataSaga() {
  yield all([
    takeLatest(FETCH_SCHEMASELECTION_REQUEST, fetchSchemaSelectionSaga),
  ]);
}

export default schemaDataSaga;